import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import DatePickerItem from "../../components/datePickerItem/datePickerItem.component";
import OtherDays from "../otherDays/otherDays.component";
import { CalenderStyled } from "./calender.styles";
import {
  // selectNewRequestBarnameh,
  selectNewRequestDaysAhead,
} from "../../redux/newRequest/newRequest.selectors";
import { toPersianNum } from "../../assets/utils";
import { Animated } from "react-animated-css";

const Calender = ({ days, setTheState, daysAhead }) => {
  //   console.log(selectNewRequestDaysAhead);
  //   const daysAhead = selectNewRequestDaysAhead;
  //   debugger;

  if (!daysAhead) return null;
  return (
    <Animated
      animationIn="bounceInDown"
      animationOut="bounceOutUp"
      animationInDuration={500}
      animationOutDuration={500}
      isVisible={true}
      className="animated"
    >
      <CalenderStyled>
        <div className="d-flex align-items-center justify-content-between">
          <div className="flex-grow-1 h-100 ml-2">
            <DatePickerItem
              key="0"
              title={daysAhead[0].name}
              subTitle={`${daysAhead[0].dayofweek_persian} ${toPersianNum(
                daysAhead[0].label_value
              )}`}
              className="w-100 h-100"
              info={daysAhead[0]}
            />
          </div>
          <div className="flex-grow-1">
            <DatePickerItem
              key="1"
              title="فردا"
              className="w-100"
              info={daysAhead[1]}
            />
            <DatePickerItem
              key="2"
              title="پس‌فردا"
              className="w-100"
              info={daysAhead[2]}
            />
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-between">
          <DatePickerItem
            key="3"
            title={daysAhead[3].dayofweek_persian}
            subTitle={toPersianNum(daysAhead[3].label_value)}
            className="flex-grow-1 flex-basis--50"
            info={daysAhead[3]}
          />
          <DatePickerItem
            key="4"
            title={daysAhead[4].dayofweek_persian}
            subTitle={toPersianNum(daysAhead[4].label_value)}
            className="flex-grow-1 flex-basis--50"
            info={daysAhead[4]}
          />
          <DatePickerItem
            key="5"
            title={daysAhead[5].dayofweek_persian}
            subTitle={toPersianNum(daysAhead[5].label_value)}
            className="flex-grow-1 flex-basis--50"
            info={daysAhead[5]}
          />
          <DatePickerItem
            key="6"
            title={daysAhead[6].dayofweek_persian}
            subTitle={toPersianNum(daysAhead[6].label_value)}
            className="flex-grow-1 flex-basis--50"
            info={daysAhead[6]}
          />
        </div>

        <OtherDays days={daysAhead} />
      </CalenderStyled>
    </Animated>
  );
};

const mapStateToProps = createStructuredSelector({
  daysAhead: selectNewRequestDaysAhead,
});

export default connect(mapStateToProps)(Calender);
